import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import RankService from '@/service/rank';
import Bus from '@/util/eventBus';
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
import LightBrand from '../LightBrand/LightBrand.vue';
import FansRank from '../FansRank/FansRank.vue';
import setting from './setting';

var HuoMask = function HuoMask() {
  return import('../HuoMask/HuoMask.vue');
};

var FriendPop = function FriendPop() {
  return import('../FriendPop/FriendPop.vue');
};

var Pop = function Pop() {
  return import('../Pop/Pop.vue');
};

var RulePop = function RulePop() {
  return import('../RulePop/RulePop.vue');
};

export default {
  props: {
    num: {
      type: Number,
      default: 2
    }
  },
  components: {
    CommonTitle: CommonTitle,
    LightBrand: LightBrand,
    FansRank: FansRank,
    FriendPop: FriendPop,
    Pop: Pop,
    HuoMask: HuoMask,
    RulePop: RulePop
  },
  data: function data() {
    return {
      list: [],
      showRulePop: {
        status: false,
        content: ''
      },
      showFriendPop: false,
      setting: setting,
      isRankEnd: false
    };
  },
  created: function created() {
    this.getRank();
    this.checkRankEnd();
    Bus.$on('buyTicketSuccess', this.refresh);
  },
  computed: {
    top5List: function top5List() {
      // friendPop为复用弹窗，统一字段
      var list = this.list.slice(0, setting.福利2.中奖人数);
      return list.map(function (item) {
        return {
          nick: item.userName,
          headurl: item.imgUrl,
          level: item.level,
          rightText: "".concat(item.totalTicketNum, "\u4EFD")
        };
      });
    },
    now: function now() {
      return this.$store.state.now;
    }
  },
  methods: {
    getRank: function getRank() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return RankService.getRank({
                  userNum: 11
                });

              case 3:
                res = _context.sent;
                _this.list = res.userList || [];
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error('err: ', _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    openRule: function openRule(type) {
      if (type === '福利2' && this.isRankEnd) {
        // 判断是否截榜
        this.showFriendPop = true;
      } else {
        this.showRulePop.status = true;
        this.showRulePop.content = setting[type]['规则内容'];
      }
    },
    checkRankEnd: function checkRankEnd() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var rankEndTime;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rankEndTime = new Date(window.setting.榜单截止时间).getTime();

                if (_this2.now >= rankEndTime) {
                  _this2.isRankEnd = true;
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    refresh: function refresh() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 有接口缓存，隔3s再请求
                setTimeout(function () {
                  _this3.getRank();

                  _this3.$refs.lightBrand.refresh();
                }, 5000);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};